// Helper to fetch current user's group IDs from Microsoft Graph
// Uses MSAL instance to acquire a Graph access token silently.
export async function fetchCurrentUserGroupIds(instance, account) {
  if (!instance || !account) return [];

  // Directory.Read.All is typically required for getMemberGroups
  const scopes = ["User.Read", "Directory.Read.All"];
  try {
    let tokenResponse;
    try {
      tokenResponse = await instance.acquireTokenSilent({ account, scopes });
    } catch (err) {
      // Signal that interaction/consent is required to the caller. Do NOT attempt popup here
      console.warn('acquireTokenSilent failed — interactive consent required or token expired:', err && err.message);
      // Throw a specific error so callers can trigger redirect-based acquisition
      const e = new Error('interaction_required');
      e.cause = err;
      throw e;
    }
    const accessToken = tokenResponse.accessToken;

    const res = await fetch("https://graph.microsoft.com/v1.0/me/getMemberGroups", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ securityEnabledOnly: false }),
    });

    if (!res.ok) {
      const text = await res.text();
      console.error('[graph] non-ok response body:', text);
      throw new Error(`Graph getMemberGroups failed: ${res.status} ${text}`);
    }

    const json = await res.json();
    // json.value should be an array of group IDs
    return Array.isArray(json.value) ? json.value : [];
  } catch (err) {
    // Common failure: InteractionRequiredAuthError (no consent) or insufficient permissions
    console.error("fetchCurrentUserGroupIds error:", err);
    // Re-throw so higher-level code can decide to request interactive consent
    throw err;
  }
}